import continueTemplate from '@/assets/continueTemplates/continue.svg';
import continueSmallTemplate from '@/assets/continueTemplates/continue-small.svg';

interface ContinueWatchingTemplate {
  id: string;
  name: string;
  preview: string;
  background: string;
  textColor: string;
  description?: string;
  svgTemplate?: string; // Caminho para o template SVG
}

export const continueWatchingTemplates: ContinueWatchingTemplate[] = [
  {
    id: 'continue',
    name: 'Padrão',
    preview: continueTemplate,
    background: '#2563EB',
    textColor: '#FFFFFF',
    description: 'Template padrão completo',
    svgTemplate: continueTemplate
  },
  {
    id: 'continueSmall',
    name: 'Compacto',
    preview: continueSmallTemplate,
    background: '#2563EB',
    textColor: '#FFFFFF',
    description: 'Template compacto',
    svgTemplate: continueSmallTemplate
  }
];
